module.exports = __webpack_public_path__ + "static/media/291969.b882daea.png";